export const API_URL = import.meta.env.VITE_API_URL ?? "http://localhost:8787";
export const WEB_URL = import.meta.env.VITE_WEB_URL ?? "http://localhost:5173";
export const EXTENSION_ID = import.meta.env.VITE_EXTENSION_ID ?? "";
// Extension store URLs, per browser, pointed at their real listings: Chrome
// (CWS id fedean…), Edge (Add-ons CRX id clgmha…), Firefox (AMO slug jobwarp,
// locale-less so AMO redirects each visitor to their own locale). Edge and
// Firefox render "not found" until their store approves and publishes the
// listing. Override per environment via VITE_*_STORE_URL on the web Pages
// project.
export const CHROME_STORE_URL = import.meta.env.VITE_CHROME_STORE_URL ?? "https://chromewebstore.google.com/detail/fedeanohobagbjondeeghbebabbbkbmm";
export const EDGE_STORE_URL = import.meta.env.VITE_EDGE_STORE_URL ?? "https://microsoftedge.microsoft.com/addons/detail/clgmhaakfpejfckohmjbdncbfdmjcofa";
export const FIREFOX_STORE_URL = import.meta.env.VITE_FIREFOX_STORE_URL ?? "https://addons.mozilla.org/firefox/addon/jobwarp/";
